// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,

  // អេសអាយធី
  bizMobServer: "https://iocareapp.coway.com",

  googleMapAPI: 'AIzaSyDA8YEpdGvm5HGlLOQGxj4IWpqpZXdRvtw', // not used here location in index.html.

  // អេសអាយធី

  // SIT Server
  // OMMServer: {
  //   server: "https://tm.dgbcambodia.com",
  //   port:"6443",
  //   context:"online-merchant"
  // },

  // UAT Server
  OMMServer: {
    server: "https://merchant.dgbbank.com.kh",
    port: "6443",
    context: "online-merchant"
  },

  // LOCAL
  // OMMServer : {
  //   server : "http://127.0.0.1",
  //   port : "8182",
  //   context : "online-merchant"
  // },

  // OMMServer : {
  //   server : "http://124.108.52.121",
  //   port : "9643",
  //   context : "bizmob.corp.server"
  // },

  // OMMServer: {
  //   server: "http://192.168.251.135",
  //   port:"8182",
  //   context:"online-merchant"
  // },

  googleAnalytics: {
    trackingID: "UA-179461532-1"
  },

  // Auto Logout Time (min * sec * millsec)
  autoLogoutTime: 10 * 60 * 1000,

  // Encryption Use setting
  encryptionUse: true,

  env : "SIT"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error'; // Included with Angular CLI.
